import FullscreenLoader from './ FullscreenLoader';

export default FullscreenLoader;
